<template>
  <!-- EXTERNAL -->
  <div v-if="trigger.externalType == 'KEYBOARD'" :class="{ disabled: trigger.disabled }">
    <i class="barcode icon" title="KEYBOARD" />
    <span v-if="trigger.configuration.mode == 'lookback' || !trigger.configuration.mode">
      {{
        $t('KEYBOARD_META_LOOKBACK', {
          match: trigger.configuration.match,
          lookbackMs: trigger.configuration.lookbackMs || 0
        })
      }}
    </span>
    <span v-if="trigger.configuration.mode == 'debounce'">
      {{
        $t('KEYBOARD_META_DEBOUNCE', {
          match: trigger.configuration.match,
          debounceMs: trigger.configuration.debounceMs || 0
        })
      }}
    </span>
  </div>
  <div v-else-if="trigger.externalType == 'HOTKEY'" :class="{ disabled: trigger.disabled }">
    <i class="keyboard icon" title="HOTKEY" />
    <span
      v-html="
        $t('HOTKEY_META', {
          keys: ld.join(ld.map(trigger.configuration.keys, k => `<kbd>${k}</kbd>`), ''),
          modifiers: ld.join(ld.map(trigger.configuration.modifiers, k => `<kbd>${k}</kbd>`), '')
        })
      "
    ></span>
  </div>
  <div v-else-if="trigger.externalType == 'CRON'" :class="{ disabled: trigger.disabled }">
    <i class="clock icon" title="CRON" /> {{ humanCron(trigger.configuration.cron) }} (<span
      class="monospaced"
      >{{ trigger.configuration.cron }}</span
    >)
  </div>

  <div v-else-if="trigger.externalType == 'WINDOW_SHOWN'" :class="{ disabled: trigger.disabled }">
    <i class="desktop icon" :title="trigger.externalType" />
    <span
      v-html="
        $t('WINDOW_META', {
          type: trigger.externalType,
          title: trigger.configuration.title,
          class: trigger.configuration.class
        })
      "
    ></span>
  </div>
  <div v-else-if="trigger.externalType == 'TABLE'" :class="{ disabled: trigger.disabled }">
    <i class="table icon" title="TABLE" />
    <router-link :to="{ name: 'table-home', params: { tableId: trigger.configuration.tableId } }">{{
      nameOfTable(trigger.configuration.tableId)
    }}</router-link>
  </div>
  <div v-else-if="trigger.externalType == 'FILESYSTEM'" :class="{ disabled: trigger.disabled }">
    <i class="open folder icon" title="FILESYSTEM" />
    <span
      v-html="
        $t('FILESYSTEM_META', {
          directory: trigger.configuration.directory,
          match: trigger.configuration.match
        })
      "
    ></span>
  </div>
  <div v-else-if="trigger.externalType == 'INTERCEPT'" :class="{ disabled: trigger.disabled }">
    <i class="mouse pointer icon" title="INTERCEPT" />
    <span
      v-html="
        $t('INTERCEPT_META', {
          eventType: trigger.configuration.eventType,
          fieldId: trigger.configuration.fieldId,
          fieldName: nameOfField(trigger.configuration.fieldId)
        })
      "
    ></span>
  </div>
  <!-- CONTEXT -->
  <div v-else-if="type == 'context'" :class="{ disabled: trigger.disabled }">
    <i class="share alternate icon" title="CONTEXT" />
    <span
      v-html="
        $t('CONTEXT_META', {
          subject: trigger.subject,
          oldmatch: trigger.regexpOld,
          newmatch: trigger.regexpNew
        })
      "
    ></span>
  </div>
  <!-- LIFECYCLE -->
  <div
    v-else-if="type == 'lifecycle' && trigger.event != 'NAVIGATED'"
    :class="{ disabled: trigger.disabled }"
  >
    <i class="history icon" title="LIFECYCLE" />
    <span v-html="$t('LIFECYCLE_META', { event: trigger.event })"></span>
  </div>
  <div
    v-else-if="type == 'lifecycle' && trigger.event == 'NAVIGATED'"
    :class="{ disabled: trigger.disabled }"
  >
    <i class="history icon" title="LIFECYCLE" />
    <span
      v-html="$t('LIFECYCLE_NAVIGATED_META', { fromUrl: trigger.fromUrl, toUrl: trigger.toUrl })"
    ></span>
  </div>
  <!-- SERVICES -->
  <div
    v-else-if="type == 'services' && trigger.serviceType == 'MAIL'"
    :class="{ disabled: trigger.disabled }"
  >
    <i class="mail icon" title="LIFECYCLE" />
    <span
      v-html="
        $t('MAIL_SERVICE_TRIGGER_META', {
          attachments: trigger.configuration.attachments,
          body: trigger.configuration.body,
          cc: trigger.configuration.ccAddress,
          from: trigger.configuration.fromAddress,
          serviceName: nameOfService(trigger.configuration.serviceId),
          subject: trigger.configuration.subject,
          to: trigger.configuration.toAddress
        })
      "
    ></span>
  </div>
  <div
    v-else-if="type == 'services' && trigger.serviceType == 'SERIALPORT'"
    :class="{ disabled: trigger.disabled }"
  >
    <i class="microchip icon" title="LIFECYCLE" />
    <span
      v-html="
        $t('SERIALPORT_SERVICE_TRIGGER_META', {
          messagePattern: trigger.configuration.messagePattern,
          serviceName: nameOfService(trigger.configuration.serviceId)
        })
      "
    ></span>
  </div>
  <div
    v-else-if="type == 'services' && trigger.serviceType == 'MQ'"
    :class="{ disabled: trigger.disabled }"
  >
    <i class="sitemap icon" title="LIFECYCLE" />
    <span
      v-html="
        $t('MQ_META', {
          messagePattern: trigger.configuration.messagePattern,
          serviceName: nameOfService(trigger.configuration.serviceId)
        })
      "
    ></span>
  </div>
  <div class="monospaced" v-else>{{ type }} / {{ trigger }}</div>
</template>

<style lang="scss" scoped>
@charset "utf-8";

.disabled {
  opacity: 0.3;
}
</style>
<script>
// @flow
import _ from 'lodash'
import prettycron from 'prettycron'

export default {
  name: 'triggercell',

  props: {
    trigger: { type: Object, default: () => {} },
    type: { type: String, default: () => '' },
    nameOfField: { type: Function, default: id => id },
    nameOfTable: { type: Function, default: id => id },
    nameOfService: { type: Function, default: id => id }
  },

  data: function() {
    return {
      ld: _
    }
  },

  methods: {
    humanCron(c) {
      return prettycron.toString(c, c.split(' ').length === 6)
    }
  }
}
</script>
